import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { AppConstant } from "src/app/app.constant";



@Injectable({
    providedIn: 'root'
  })
  export class ActivityTypeService {
    apiUrl: string;
    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
      this.apiUrl = this.appConstant.getUrl()
    }
    manageActivityType(event) {
      return this.httpClient.post(`${this.apiUrl}/manageActivityType`, event).pipe(
        map((response: any) => {
          return response;
        })
      )
    }
    public getAllActivityType(): Observable<DataResult> {
      return this.httpClient.get(`${this.apiUrl}/getAllActivityType/`).pipe(
        map((response: any) => {
          return {
            data: response.data,
            total: response.total
          } as GridDataResult
        })
      ) as any as Observable<GridDataResult>
    }
 
    getActivityTypeById(Id: number) {
      return this.httpClient.get(`${this.apiUrl}/getActivityTypeById/` + Id).pipe(
        map((response: any) => {
          return response.data;
        })
      )
    }
    public getAllActivityTypeName(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllActivityTypeName/`).pipe(
          map((response: any) => {
            return {
              data: response.data,
              total: response.total
            } as GridDataResult
          })
        ) as any as Observable<GridDataResult>
      }
  }
  
  